var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8029 3.00195H9.30335C4.80375 3.00195 3.00391 4.80179 3.00391 9.30139V14.7009C3.00391 19.2005 4.80375 21.0004 9.30335 21.0004",
    stroke: "white",
    strokeWidth: 1.1699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0039 10.2012V12.9009",
    stroke: "white",
    strokeWidth: 1.1699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.004 10.2013H17.4044C14.7046 10.2013 13.8047 9.30139 13.8047 6.60163V3.00195L21.004 10.2013Z",
    stroke: "white",
    strokeWidth: 1.1699,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5861 17.6364C11.4713 17.7894 11.4713 20.8491 13.5861 21.0021H18.5897C19.1926 21.0021 19.7866 20.7771 20.2275 20.3722C21.7124 19.0763 20.9205 16.4845 18.9676 16.2415C18.2657 12.0209 12.1642 13.6228 13.6041 17.6454",
    stroke: "white",
    strokeWidth: 1.1699,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayroll);
export default __webpack_public_path__ + "static/media/payroll.c75b20c7d3a4b225cd0d472e2da2f969.svg";
export { ForwardRef as ReactComponent };